export default __webpack_public_path__ + "5bfd93516b90047501a3a66ecc05013c.png";